import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { BrowserRouter as Router } from "react-router-dom";
import { CssBaseline } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import * as Sentry from "@sentry/react";

import NotifierProvider from "providers/NotifierProvider";
import ThemeProvider from "providers/ThemeProvider";
import AppDataSynchronizer from "containers/App/AppDataSynchronizer";
import AppStatusWrapper from "containers/App/AppStatusWrapper";
import AuthWrapper from "containers/App/AuthWrapper";
import ErrorBoundaryFallback from "containers/App/ErrorBoundaryFallback";
import GlobalNotification from "containers/App/GlobalNotification";
import LocalStorageInitializer from "containers/App/LocalStorageInitializer";
import RealtimeListener from "containers/App/RealtimeListener";
import RoutesWrapper from "containers/App/RoutesWrapper";
import ServiceWorkerWrapper from "containers/App/ServiceWorkerWrapper";
import UrlHandler from "containers/App/UrlHandler";
import EmojiPickerInitializer from "containers/App/EmojiPickerInitializer";
import MobileNativeListener from "containers/App/MobileNativeListener/MobileNativeListener";
import RegisterPushNotifications from "containers/App/RegisterPushNotifications";
import AppFocus from "containers/App/AppFocus/AppFocus";

function App(): JSX.Element {
  return (
    <Router>
      <ThemeProvider>
        <CssBaseline />
        <Sentry.ErrorBoundary fallback={<ErrorBoundaryFallback />}>
          <AppFocus />
          <RegisterPushNotifications />
          <ServiceWorkerWrapper>
            <NotifierProvider>
              <GlobalNotification />
              <LocalStorageInitializer />
              <MobileNativeListener />
              <AppStatusWrapper>
                <UrlHandler>
                  <AuthWrapper>
                    <AppDataSynchronizer />
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <RealtimeListener>
                        <EmojiPickerInitializer />
                        <RoutesWrapper />
                      </RealtimeListener>
                    </LocalizationProvider>
                  </AuthWrapper>
                </UrlHandler>
              </AppStatusWrapper>
            </NotifierProvider>
          </ServiceWorkerWrapper>
        </Sentry.ErrorBoundary>
      </ThemeProvider>
    </Router>
  );
}

export default App;
